import { render, staticRenderFns } from "./PriceIndicationsIndex.vue?vue&type=template&id=35d4d41d"
import script from "./PriceIndicationsIndex.vue?vue&type=script&lang=js"
export * from "./PriceIndicationsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports